import { DueDiligenceFormType } from 'src/pages/Dashboard/components/DueDiligence/types';
import { DueDiligenceStatus } from './adminListing';
import type { StructuredQuestionnaire } from './structuredQuestionnaire';
import type {
  DueDiligenceItemScreeningStatus,
  DueDiligenceScreeningStatus,
  DueDiligenceSectionDto,
} from './dueDiligenceSections';
import type { BusinessVerificationDto, ItemConfigJson } from './businessVerification';

export interface UpdateDueDiligenceItemFieldsPayload {
  itemId: string;
  itemFields: StructuredQuestionnaire | null;
  itemFieldsPopulated: boolean;
}

export interface DueDiligenceItemAttachmentResponse {
  id: string;
  fileName: string;
  contentType?: string;
  fileSize?: number;
  markedFinal?: boolean;
  createdAt?: string;
  conversationId?: string | null;
}

export interface DueDiligenceClient {
  dueDiligenceId: string;
  companyName: string;
  clientCode: string;
  dueDiligenceType: DueDiligenceFormType | null;
}

export type DueDiligenceDetails = {
  id: string;
  clientCode: string;
  companyName: string;
  templateType: string;
  dueDate: string;
  status: DueDiligenceStatus;
  closedAt: string;
  closedBy: string;
  createdAt: string;
  clayrioAnalysisStatus: DueDiligenceScreeningStatus;
};

export enum DueDiligenceItemStatus {
  NOT_STARTED = 'NOT_STARTED',
  DRAFT = 'DRAFT',
  NEEDS_ATTENTION = 'NEEDS_ATTENTION',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  RECEIVED = 'RECEIVED',
}

export enum DueDiligenceUserRole {
  ADMIN = 'ADMIN',
  CLIENT = 'CLIENT',
}

export interface DueDiligenceItem {
  id: string;
  sectionName: string;
  itemText: string;
  sortOrder: string;
  responseRequired: boolean;
  status: DueDiligenceItemStatus;
  needsAttentionFrom: DueDiligenceUserRole;
  finalComment: string;
  markedNotApplicable: boolean;
  approvedNotApplicable: boolean;
  receivedAt: string;
  receivedBy: string;
  createdAt: string;
  updatedAt?: string;
  category?: string;
  processing: boolean;
  screeningStatus: DueDiligenceItemScreeningStatus | null;
  sections?: DueDiligenceSectionDto[] | null;
  itemFields?: StructuredQuestionnaire | null;
  configJson?: ItemConfigJson | null;
  businessVerification?: BusinessVerificationDto | null;
}

export interface DueDiligenceViewResponse {
  dueDiligence: DueDiligenceDetails;
  screeningStatus: DueDiligenceScreeningStatus | null;
  items: DueDiligenceItem[];
}

export enum DueDiligenceOverallRiskLevel {
  NO_RISK = 'NO_RISK',
  LOW_RISK = 'LOW_RISK',
  HIGH_RISK = 'HIGH_RISK',
}
export interface DueDiligenceSummaryResponse {
  overallRiskLevel: DueDiligenceOverallRiskLevel;
  comment: string;
  items: DueDiligenceSummaryItem[];
}

export interface DueDiligenceSummaryItem {
  id: string;
  sectionName: string;
  itemText: string;
  sortOrder: string;
  responseRequired: boolean;
  status: DueDiligenceItemStatus;
  finalComment: string;
  finalFiles: DueDiligenceSummaryFile[];
}

export interface DueDiligenceSummaryFile {
  id: string;
  fileName: string;
  contentType: string;
  fileSize: number;
}

export interface CloseDueDiligencePayload {
  clientCode: string;
  overallRiskLevel: DueDiligenceOverallRiskLevel;
  comment: string;
}
